import Vue from 'vue'
import Router from 'vue-router'

import AuxiliaryLayout from '@/views/layout/AuxiliaryLayout.vue'
import Login from '@/views/login/Login.vue'
import Page404 from '@/views/layout/Page404.vue'
import ModifyGrade from '@/views/verification/ModifyGrade.vue'
import ModifyFeedback from '@/views/verification/ModifyFeedback.vue'
import ModifyBasicGrades from '@/views/verification/ModifyBasicGrades.vue'
import ModifyQuizGrades from '@/views/verification/ModifyQuizGrades.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/404',
      name: '404',
      component: Page404
    },
    {
      path: '/verification',
      name: 'verification',
      component: AuxiliaryLayout,
      redirect: {
        name: 'modifyGrade'
      },
      children: [
        {
          path: 'modify-grade',
          name: 'modifyGrade',
          component: ModifyGrade,
          beforeEnter: (to, from, next) => {
            const query = to.query
            if (
              query.studentId &&
              query.courseId &&
              query.academic &&
              query.term &&
              query.id
            ) {
              next()
            } else {
              next({ name: '404' })
            }
          }
        },
        {
          path: 'modify-feedback',
          name: 'modifyFeedback',
          component: ModifyFeedback,
          beforeEnter: (to, from, next) => {
            const query = to.query
            if (query.studentId && query.academic && query.term && query.id) {
              next()
            } else {
              next({ name: '404' })
            }
          }
        },
        {
          path: 'modify-basic-grades',
          name: 'modifyBasicGrades',
          component: ModifyBasicGrades,
          beforeEnter: (to, from, next) => {
            const query = to.query
            if (
              query.studentId &&
              query.academic &&
              query.semester &&
              query.courseId &&
              query.weekId
            ) {
              next()
            } else {
              next({ name: '404' })
            }
          }
        },
        {
          path: 'modify-quiz-grades',
          name: 'modifyQuizGrades',
          component: ModifyQuizGrades,
          beforeEnter: (to, from, next) => {
            const query = to.query
            if (
              query.studentId &&
              query.academic &&
              query.semester &&
              query.courseId &&
              query.quizId
            ) {
              next()
            } else {
              next({ name: '404' })
            }
          }
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    }
  ]
})
